import { render, staticRenderFns } from "./taskDetails.vue?vue&type=template&id=7c43805a&scoped=true&"
import script from "./taskDetails.vue?vue&type=script&lang=js&"
export * from "./taskDetails.vue?vue&type=script&lang=js&"
import style0 from "./taskDetails.vue?vue&type=style&index=0&id=7c43805a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c43805a",
  null
  
)

export default component.exports